<mat-card appearance="outlined">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" color="primary" />
  }
  <mat-card-header class="flex-row">
    <mat-card-title>Users</mat-card-title>
    <div class="text-right flex-1">
      <lib-button icon="add_shopping_cart" (buttonClick)="addAdvertiser()">Add Advertiser User</lib-button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="users$ | async">
      <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <img mat-card-avatar [src]="assertType(element).avatarLowUrl" alt="User Avatar">
        </ng-container>

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef> Roles </th>
          <td mat-cell *matCellDef="let element">
            @if (assertType(element).isOwner) {
              <span><mat-icon>add_business</mat-icon></span>
            }
            @if (assertType(element).isAdvertiser) {
              <span><mat-icon>add_shopping_cart</mat-icon></span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{ assertType(element).name }} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Phone </th>
          <td mat-cell *matCellDef="let element"> {{ assertType(element).phoneNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            @if ((assertType(element).isAdvertiser || assertType(element).isOwner) && !(assertType(element).isAdvertiser && assertType(element).isOwner)) {
              <lib-button variant="icon" icon="delete" color="primary" (buttonClick)="onRemove(element, assertType(element).isAdvertiser, assertType(element).isOwner)">Remove</lib-button>
            }

            @if (assertType(element).isAdvertiser && assertType(element).isOwner) {
              <lib-button  variant="icon" icon="delete" color="primary" [matMenuTriggerFor]="removeRoleMenu">Remove Advertiser role</lib-button>
            }
            <mat-menu #removeRoleMenu="matMenu">
              <button mat-menu-item (click)="onRemove(element, true, false)">Remove Advertiser role</button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['roles','name','phone','actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['roles','name','phone','actions'];"></tr>
      </table>

    </mat-card-content>
  </mat-card>
